export default __webpack_public_path__ + "static/media/zConnect Autopayment Guide.6d9cec91.pdf";